<template>
  <wishlist-btn
    :empi="empi"
    :epi="epi"
    :du="du"
    :dt="dt"
    :source="source"
    :cprops="JSON.stringify(cprops)"
    :quick-view="quickView"
    class="Wishlist"
    role="button"
    aria-label="Save product to wishlist"
    aria-disabled="false"
    title="Save"
    disabled="false"
    tabindex="0"
  >
    <Icon icon="heart-sm" />
    <Icon icon="heart-lg" />
  </wishlist-btn>
</template>

<script setup>
import Icon from './Icon.vue';

const props = defineProps({
  empi: {
    type: Number,
    required: true,
  },
  epi: {
    type: Number,
    required: true,
  },
  du: {
    type: String,
    required: true,
  },
  dt: {
    type: String,
    required: true,
  },
  source: {
    type: String,
    required: false,
    default: '',
  },
  cprops: {
    type: Object,
    required: true,
  },
  quickView: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>
